<template>
    <component
            :is="component"
            v-bind="props"

            :name="name"
            :form="form"

            :vuelidator="vuelidator"

            :filled="filled"
           
            @input="handleComponentInput"
    />
</template>

<script>
   

    export default {
        name: "DynamicField",
        props: {
            element: {
                type: Object,
                required: true
            },
        
            name: {
                type: String,
                required: true
            },

            form: {
                type: Object,
                required: true
            },

            vuelidator: {
                type: Object,
                required: false
            },

            count: {
                type: Number,
                required: false,
                default: 1
            },

            index: {
                type: Number,
                required: false,
                default: 0
            },

            filled: {
                type: Boolean,
                required: false,
                default: false
            }
        },

        computed: {
            component() {
                const componentName = this.element.component;
                //alert(this.element.test);
                return () => import(`./${componentName}`);
            },
            
            props() {
                return {...this.element, count: this.count, index: this.index};
            }
        },

        methods: {



            handleComponentInput (value) {



                this.$emit('input', value);

               // console.log('legit ' + value)
            }
        },



        created() {

           // console.log(this.element);


           // console.log('created renderer')
/*setTimeout(() => {


 this.$parent.$set(this.$parent.form, 'test', 'none')

      }, 3000)*/

          
        },


        mounted(){

            //this.echo('dynamic_field_mounted');


            //console.log('dynamic field mounted')
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/DynamicField.vue